(() => {
  if (window.pbxCatalogReady) return;
  window.pbxCatalogReady = true;
  const initialized = new WeakSet();
  const media = window.matchMedia('(min-width: 990px)');
  function init(root = document) {
    const catalogs = [];
    if (root.matches?.('[data-pbx-catalog]')) catalogs.push(root);
    catalogs.push(...root.querySelectorAll('[data-pbx-catalog]'));
    catalogs.forEach(catalog => {
      if (initialized.has(catalog)) return;
      initialized.add(catalog);
      catalog.classList.add('pbx-catalog--enhanced');
      const panel = catalog.querySelector('[data-pbx-filter-panel]');
      if (panel && !panel.matches('.pbx-catalog__interests')) {
        panel.open = media.matches || Boolean(panel.querySelector('.pbx-catalog__filter-total'));
        panel.addEventListener('click', event => {
          if (event.target.closest('summary')?.parentElement === panel) panel.dataset.pbxUserToggled = 'true';
        });
      }
      catalog.querySelectorAll('[data-pbx-filter-form]').forEach(form => {
        form.addEventListener('formdata', event => {
          form.querySelectorAll('input[type="number"]').forEach(input => {
            if (input.name && input.value.trim() === '') event.formData.delete(input.name);
          });
        });
        form.addEventListener('invalid', event => {
          let details = event.target.closest('details');
          while (details && form.contains(details)) {
            details.open = true;
            details = details.parentElement?.closest('details');
          }
        }, true);
      });
    });
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-pbx-sort]');
    if (!select) return;
    const form = select.closest('[data-pbx-filter-form]');
    if (form) form.requestSubmit();
  });
  media.addEventListener('change', () => {
    document.querySelectorAll('[data-pbx-filter-panel]').forEach(panel => {
      if (panel.matches('.pbx-catalog__interests') || panel.dataset.pbxUserToggled === 'true') return;
      panel.open = media.matches || Boolean(panel.querySelector('.pbx-catalog__filter-total'));
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
